import { isAxiosError } from 'axios';

export type AccountError =
  | { type: 'AuthRequired'; status: 401; message: string }
  | { type: 'UsernameTooLong'; status: 400; message: string }
  | { type: 'PasswordTooLong'; status: 400; message: string }
  | { type: 'InsufficientGradeToCreate'; status: 400; message: string }
  | { type: 'ForbiddenDeleteAdmin'; status: 403; message: string }
  | { type: 'ForbiddenDeleteNotChild'; status: 403; message: string }
  | { type: 'ResetPasswordForbidden'; status: 403; message: string }
  | { type: 'NewPasswordMissing'; status: 400; message: string }
  | { type: 'NewPasswordTooLong'; status: 400; message: string }
  | { type: 'NotFound'; status: 404; message: string }
  | { type: 'ServerError'; status: 500; message: string }
  | { type: 'Unknown'; status?: number; message: string };

const getMessage = (data: any): string => {
  if (!data) return '알 수 없는 오류가 발생했습니다.';
  if (typeof data === 'string') return data;
  if (data.detail) return String(data.detail);
  if (data.error) return String(data.error);
  if (data.non_field_errors?.length) return String(data.non_field_errors[0]);
  if (data.username?.length) return String(data.username[0]);
  if (data.password?.length) return String(data.password[0]);
  return JSON.stringify(data);
};

export function mapCreateOrUpdateAccountError(err: unknown): AccountError {
  if (isAxiosError(err)) {
    const status = err.response?.status;
    const data = err.response?.data as any;
    if (status === 401) return { type: 'AuthRequired', status, message: getMessage(data) };
    if (status === 400) {
      if (data?.username) return { type: 'UsernameTooLong', status, message: data.username[0] };
      if (data?.password) return { type: 'PasswordTooLong', status, message: data.password[0] };
      if (data?.non_field_errors) return { type: 'InsufficientGradeToCreate', status, message: data.non_field_errors[0] };
      return { type: 'Unknown', status, message: getMessage(data) };
    }
    if (status && status >= 500) return { type: 'ServerError', status: 500, message: getMessage(data) };
    return { type: 'Unknown', status, message: getMessage(data) };
  }
  return { type: 'Unknown', message: (err as any)?.message || '알 수 없는 오류가 발생했습니다.' };
}

export function mapDeleteAccountError(err: unknown): AccountError {
  if (isAxiosError(err)) {
    const status = err.response?.status;
    const data = err.response?.data as any;
    const msg = getMessage(data);
    if (status === 403) {
      if (msg.includes('마스터')) return { type: 'ForbiddenDeleteAdmin', status, message: msg };
      return { type: 'ForbiddenDeleteNotChild', status, message: msg };
    }
    if ((status ?? 0) >= 500) return { type: 'ServerError', status: 500, message: msg };
    return { type: 'Unknown', status, message: msg };
  }
  return { type: 'Unknown', message: (err as any)?.message || '알 수 없는 오류가 발생했습니다.' };
}

export function mapResetPasswordError(err: unknown): AccountError {
  if (isAxiosError(err)) {
    const status = err.response?.status;
    const data = err.response?.data as any;
    const msg = getMessage(data);
    if (status === 403) return { type: 'ResetPasswordForbidden', status, message: msg };
    if (status === 404) return { type: 'NotFound', status, message: msg };
    if (status === 400) {
      if (msg.includes('필수')) return { type: 'NewPasswordMissing', status, message: msg };
      if (msg.includes('20자')) return { type: 'NewPasswordTooLong', status, message: msg };
      return { type: 'Unknown', status, message: msg };
    }
    if (status && status >= 500) return { type: 'ServerError', status: 500, message: msg };
    return { type: 'Unknown', status, message: msg };
  }
  return { type: 'Unknown', message: (err as any)?.message || '알 수 없는 오류가 발생했습니다.' };
}


